import * as Sentry from "@sentry/react"
import { env } from "@src/utility/GlobalUtils"
// Use the same history instance the app/router uses to ensure navigation transactions are captured
import history from '@src/router/history'

if (env("REACT_APP_SENTRY_DSN", "") !== "") {
  Sentry.init({
    dsn: env("REACT_APP_SENTRY_DSN", ""),
    environment: env("REACT_APP_SENTRY_ENVIRONMENT", env('REACT_APP_ENV', 'development')),
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    // Performance Monitoring
    tracesSampleRate: parseFloat(env("REACT_APP_SENTRY_TRACE_SAMPLE_RATE", 0.0)), //  By default, Capture 0% of the transactions
    // Session Replay
    replaysSessionSampleRate: parseFloat(env("REACT_APP_SENTRY_SESSION_SAMPLE_RATE", 0.0)), // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: parseFloat(env("REACT_APP_SENTRY_ERROR_SAMPLE_RATE", 0.0)), // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({ history }),
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: env("REACT_APP_SENTRY_UNMASK_ALL_TEXT") !== 'true',
        maskAllInputs: env("REACT_APP_SENTRY_UNMASK_ALL_INPUTS") !== 'true',
        blockAllMedia: env("REACT_APP_SENTRY_UNBLOCK_ALL_MEDIA") !== 'true',
        mutationBreadcrumbLimit: parseInt(env("REACT_APP_SENTRY_MUTATION_BREADCRUMB_LIMIT", 750)),
        mutationLimit: parseInt(env("REACT_APP_SENTRY_MUTATION_LIMIT", 10000))
      })
    ]
  })
}

// Sentry.init({
//   dsn: "https://9b77ece277b91a3127cce92ef465eaf6@sentry.flowdit.software/3",
//   environment: env("REACT_APP_SENTRY_ENVIRONMENT", process.env.NODE_ENV || "development"),

//   // This sets the sample rate to be 10%. You may want this to be 100% while
//   // in development and sample at a lower rate in production
//   replaysSessionSampleRate: 0.1,
//   // If the entire session is not sampled, use the below sample rate to sample
//   // sessions when an error occurs.
//   replaysOnErrorSampleRate: 1.0,

//   integrations: [new Replay()]
// })

// Sentry.init({
//   dsn: env("REACT_APP_SENTRY_DSN", ""),
//   integrations: [
//     // new Sentry.BrowserTracing({
//     //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     //   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/]
//     // }),
//     new Replay({
//       maskAllText: false,
//       blockAllMedia: false
//     })
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })